import { actionEqual } from './utils';
import * as ActionCreators from '../actions/ActionCreators';

const info = {
  firstName: '',
  lastName: '',
  company: '',
  phoneNumber: '',
  email: '',
  dialCode: '',
};

const defaultState: PaymentState = {
  dropinInstance: null,
  dropinToken: '',
  amount: 0,
  paymentMethod: 'offline',
  userInfo: { ...info },
  billingInfo: { ...info },
  paymentInfo: null,
  paymentType: null,
  paymentResponse: null,
  submitButtonDisabled: true,
  submitButtonLoading: false,
  captcha: undefined,
};

export default function userShopItems(
  state: PaymentState = defaultState,
  action: Action
): PaymentState {
  if (actionEqual(action, ActionCreators.setBraintreeDropinInstance)) {
    return {
      ...state,
      dropinInstance: action.payload.dropinInstance,
    };
  } else if (actionEqual(action, ActionCreators.setPublicBraintreeToken)) {
    return {
      ...state,
      dropinToken: action.payload.token,
    };
  } else if (actionEqual(action, ActionCreators.setPaymentCaptcha)) {
    return {
      ...state,
      captcha: action.payload.captcha,
    };
  } else if (actionEqual(action, ActionCreators.setPaymentMethod)) {
    return {
      ...state,
      paymentMethod: action.payload.paymentMethod,
    };
  } else if (actionEqual(action, ActionCreators.setPaymentUserInfo)) {
    return {
      ...state,
      userInfo: { ...action.payload.userInfo },
    };
  } else if (actionEqual(action, ActionCreators.setPaymentBillingInfo)) {
    return {
      ...state,
      billingInfo: { ...action.payload.billingInfo },
    };
  } else if (actionEqual(action, ActionCreators.setPaymentInfo)) {
    const { amount, paymentType, paymentInfo } = action.payload;
    return {
      ...state,
      amount,
      paymentType,
      paymentInfo,
    };
  } else if (actionEqual(action, ActionCreators.setPaymentResponse)) {
    return {
      ...state,
      paymentResponse: action.payload.response,
    };
  } else if (
    actionEqual(action, ActionCreators.setSubmitPaymentButtonDisabled)
  ) {
    return {
      ...state,
      submitButtonDisabled: action.payload.disabled,
    };
  } else if (actionEqual(action, ActionCreators.setSubmitButtonLoading)) {
    return {
      ...state,
      submitButtonLoading: action.payload.loading,
    };
  } else {
    return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/payment.ts